import { ShieldCheck } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { useSpoilers } from "@/context/SpoilerContext";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useT } from "@/lib/labels";

export const SpoilerSelect = ({ testid = "spoiler-progress" }) => {
  const { series } = useSite();
  const { progress, setFinished } = useSpoilers();
  const list = series.filter((s) => s.books?.length);
  return (
    <div className="grid gap-3">
      {list.map((s) => (
        <label key={s.id} className="block">
          <span className="block font-heading text-[11px] font-bold uppercase tracking-[0.16em] text-[#5e4a35] mb-1">{list.length > 1 ? `${s.title} — last book finished` : "Last book I've finished"}</span>
          <select data-testid={`${testid}-${s.slug}`} value={progress[s.id] || 0} onChange={(e) => setFinished(s.id, Number(e.target.value))}
            className="admin-input !py-1.5 text-sm font-heading">
            <option value={0}>Not started yet: hide every spoiler</option>
            {[...s.books].sort((a, b) => a.number - b.number).map((b) => <option key={b.id} value={b.number}>Book {b.number}: {b.title}</option>)}
          </select>
        </label>
      ))}
    </div>
  );
};

export const SpoilerShieldButton = () => {
  const { progress } = useSpoilers();
  const t = useT();
  const active = Object.values(progress).some((n) => n > 0);
  return (
    <Popover>
      <PopoverTrigger data-testid="header-spoiler-shield" title="Spoiler Shield"
        className={`p-2 border transition-colors ${active ? "border-[#2f6b3a] text-[#2f6b3a]" : "border-[#c9a227]/60 text-[#2d1b0e]"} hover:bg-[#c9a227]/20`}>
        <ShieldCheck className="w-4 h-4" />
      </PopoverTrigger>
      <PopoverContent data-testid="spoiler-shield-panel" align="end" className="vellum rounded-none w-80 p-5">
        {t("shield.eyebrow") && <p className="eyebrow">{t("shield.eyebrow")}</p>}
        {t("shield.title") && <p className="font-display text-xl mt-1 mb-2">{t("shield.title")}</p>}
        <p className="text-sm italic text-[#4a3a2a] mb-4">Spoilers from books you've finished are shown. Anything from later books stays hidden until you tap it.</p>
        <SpoilerSelect testid="shield-progress" />
      </PopoverContent>
    </Popover>
  );
};
